import { ANALYTICS_SERVICE_EVENTS } from './constants'
import { getDefaultServiceProperties } from './getDefaultServiceProperties'
import { dispatchAnalyticsEvent } from './trackSegmentEvent'

export const setupButtonTracking = () => {
  const handler = (event: MouseEvent) => {
    const target = event.target as HTMLElement // use lowercase tag
    const button = target.closest('[data-track-button], a')

    if (!button || button.hasAttribute('data-track-exclude')) return

    let parsedProps: Record<string, any> = {}
    const rawProps = button.getAttribute('data-properties')

    try {
      if (rawProps) parsedProps = JSON.parse(rawProps)
    } catch (err) {
      console.warn('Invalid JSON in data-properties:', rawProps)
    }

    const defaultProperties = getDefaultServiceProperties()

    const properties = {
      ...defaultProperties,
      ...parsedProps,
    }

    const eventId = parsedProps?.eventId
    dispatchAnalyticsEvent({
      serviceEventName: ANALYTICS_SERVICE_EVENTS.ACTION_CLICKED,
      serviceProperties: properties,
      sendSegmentEvent: false,
      eventId,
    })
  }

  document.addEventListener('click', handler, true)

  return () => {
    document.removeEventListener('click', handler, true)
  }
}
